// Imports
import { useStateValue } from '../../_global/jsx/store';

// The Quesion Counter shown at the top right of the Page when its a question

export const ReactQuestionCounter = () => {

    const [{ controlData } ] = useStateValue(); 
    
    return (
        <div className="br-app-main-content__page-counter">
            <span className="br-app-main-content__page-counter__title">Question</span>
            <span className="br-app-main-content__page-counter__number">{controlData.currentItem.counterNumber}/{controlData.noOfRapidQuestions}</span>
        </div>
    );    
};
